import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-toggle"
export default class extends Controller {
  static targets = ["passwordField", "eyeIcon", "eyeSlashIcon", "toggleButton"]

  toggle(event) {
    event.preventDefault()

    if (this.passwordFieldTarget.type === "text") {
      // Hide password
      this.passwordFieldTarget.type = "password"
      this.eyeIconTarget.classList.add("d-none")
      this.eyeSlashIconTarget.classList.remove("d-none")
    } else {
      // Show password
      this.passwordFieldTarget.type = "text"
      this.eyeIconTarget.classList.remove("d-none")
      this.eyeSlashIconTarget.classList.add("d-none")
    }
  }
}